"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStyleWithTheme = exports.checkOS = exports.copyAttribute = exports.matchId = exports.genSerialID = void 0;
var merge_1 = __importDefault(require("lodash/merge"));
var uuidjs_1 = __importDefault(require("uuidjs"));
/**
 * 根据全局唯一ID
 */
function genSerialID() {
    return uuidjs_1.default.generate();
}
exports.genSerialID = genSerialID;
function matchId(list, serial) {
    if (!list && !serial) {
        return true;
    }
    else if (list instanceof Array) {
        return list.indexOf(serial) > -1;
    }
    else {
        return list === serial;
    }
}
exports.matchId = matchId;
/**
 * 从from对象拷贝属性到to对象
 * @param to
 * @param from
 */
function copyAttribute(to, from) {
    if (!from || typeof from !== "object") {
        return;
    }
    // 自身的属性
    Object.getOwnPropertyNames(from).forEach(function (key) {
        // 可枚举的
        if (key in from) {
            // 如果不存在直接拷贝 或 为watch对象直接拷贝
            if (typeof to[key] === "undefined" || key === "watch") {
                to[key] = from[key];
            }
            // 被拷贝对象中存在且为方法
            else if (typeof to[key] === "function" && typeof from[key] === "function") {
                var toFn_1 = to[key];
                to[key] = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var fromRes = from[key].apply(to, args), toRes = toFn_1.apply(to, args);
                    if (fromRes && toRes) {
                        return merge_1.default({}, toRes, fromRes);
                    }
                    else {
                        return fromRes || toRes;
                    }
                };
            }
            else {
                console.error("\u76EE\u6807\u5BF9\u8C61\u4E2D\u5DF2\u5B58\u5728\uFF1A" + key + ", \u6216\u7C7B\u578B\u4E0D\u5339\u914D");
            }
        }
    });
}
exports.copyAttribute = copyAttribute;
function checkOS() {
    var os = function () {
        var sUserAgent = navigator.userAgent;
        var isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
        var isMac = navigator.platform == "Mac68K" ||
            navigator.platform == "MacPPC" ||
            navigator.platform == "Macintosh" ||
            navigator.platform == "MacIntel";
        if (isMac)
            return "Mac";
        var isUnix = navigator.platform == "X11" && !isWin && !isMac;
        if (isUnix)
            return "Unix";
        var isLinux = String(navigator.platform).indexOf("Linux") > -1;
        if (isLinux)
            return "Linux";
        if (isWin) {
            var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
            if (isWin2K)
                return "Win2000";
            var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
            if (isWinXP)
                return "WinXP";
            var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
            if (isWin2003)
                return "Win2003";
            var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
            if (isWinVista)
                return "WinVista";
            var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
            if (isWin7)
                return "Win7";
        }
        return "other";
    };
    return os().toLocaleLowerCase();
}
exports.checkOS = checkOS;
function buildStyleWithTheme(theme) {
    var cssText = [];
    if (!theme) {
        return cssText;
    }
    if (typeof theme.color !== "undefined") {
        cssText.push("color: " + theme.color);
    }
    if (typeof theme.background !== "undefined") {
        cssText.push("background: " + theme.background);
    }
    if (typeof theme.padding !== "undefined") {
        cssText.push("padding: " + theme.padding);
    }
    if (typeof theme.border !== "undefined") {
        cssText.push("border: " + theme.border);
    }
    return cssText;
}
exports.buildStyleWithTheme = buildStyleWithTheme;
//# sourceMappingURL=util.js.map